module.exports = true;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/babel-runtime/~/core-js/library/modules/_library.js
 ** module id = 140
 ** module chunks = 0
 **/